import React, { useState } from "react";
import styles from "./QualityControl.module.scss";

import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import { messages } from "../Workflow.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";
import { Button } from "@src/lms/jelly/extensions/ui";
import { BinauralMonitoringModal } from "./modals/BinauralMonitoring";

export const QualityControl: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <div className={styles.container}>
      {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
      <SpatialCarousel showBreadcrumbs>
        {[
          <div key={1} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.qualityControlTitle1)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.qualityControlDescription1) }}></p>
            </ui.Scrollbars>
          </div>,
          <div key={2} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.printmasteringAndPackagingTitle2)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.qualityControlDescription2) }}></p>
              <div className={styles.buttonContainer}>
                <Button
                  className={styles.button}
                  shape="round"
                  size="small"
                  onClick={() => setIsModalVisible(true)}
                  icon="cis-center-focus-weak"
                >
                  {formatMessage(messages.qualityControlButton)}
                </Button>
              </div>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.qualityControlDescription3) }}></p>
            </ui.Scrollbars>
          </div>,
        ]}
      </SpatialCarousel>
      <BinauralMonitoringModal visible={isModalVisible} onClose={() => setIsModalVisible(false)} />
    </div>
  );
};
